import Vue from 'vue'
import App from './app.vue'
import router from './router'
import store from './store'
(window as any).Vue = Vue;
// import 'element-ui/lib/theme-chalk/index.css'
import './plugins/flexible'
import 'mint-ui/lib/style.css';
import { createRequest } from '@/network/request';
import VueDialogX from 'vue-dialog-x';
// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'
import vueSwiper from 'vue-awesome-swiper'
import { Swipe, SwipeItem } from 'mint-ui';

Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.use(vueSwiper)
Vue.prototype.$axios = createRequest();
import 'animate.css'
import 'vue-fullpage/vue-fullpage.css'
import './utils/fullpage'
let VueFullpage = (window as any).VueFullpage;
Vue.config.productionTip = false
Vue.use(VueDialogX)
Vue.use(VueFullpage)

// 在 main.js 添加以下代码
import vuePicturePreview from 'vue-picture-preview'
Vue.component('Previewer', vuePicturePreview);
// Vue.use(VueDirectiveImagePreviewer)
import VuePreview from 'vue-preview'

function findParentNode(el:any, scrollDef:any) {
	let target = null;
	var ind = 0;
	function digui(el:any) {
		if (el.id == scrollDef) {
			target = el;
			return false;
		}
		if (el.parentNode) {
			digui(el.parentNode)
		}
	}
	digui(el)
	return target;
}


document.body.addEventListener('touchmove', function (evt:any) {
    var target = findParentNode(evt.target,"ruleBox");
    var target2 = findParentNode(evt.target,"main");
    if(!target&&!target2){
        evt.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
    }
}, { passive: false }); //passive 参数不能省略，用来兼容ios和android

// defalut install
Vue.use(VuePreview)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')